module.exports = __webpack_public_path__ + "static/media/loading-img.b7f39220.webp";